import PosthogService from '~/services/posthog/PosthogService';

/**
 * Why the code did not end up linked. The same five mobile reports (GOTU-8328),
 * so the two platforms break down identically:
 *
 * - `invalid` — the code cannot exist (wrong shape); no request was made.
 * - `no_match` — the server does not know it. The only reason that blocks.
 * - `unavailable` — the enumeration breaker declined to confirm.
 * - `server_error` — the lookup request itself failed.
 * - `account_exists` — the code resolved, and then the sign-up it rode failed
 *   because the email already had an account. This one is genuinely lost
 *   attribution: there is no new account for referral-service to attach the
 *   referrer to.
 *
 * The first four are the gate's, emitted before the sign-up call. Only
 * `account_exists` comes from `SignUpForm` afterwards, which is why a submit
 * reports at most one of these: a code that already failed to resolve never
 * reaches the sign-up to fail a second way.
 */
export type TReferralLinkedFailedReason =
  | 'no_match'
  | 'invalid'
  | 'unavailable'
  | 'server_error'
  | 'account_exists';

export interface IReferralLinkedFailedPayload {
  reason: TReferralLinkedFailedReason;
  /** The code as submitted, normalised — kept even when it cannot be a code. */
  referral_code: string;
}

/**
 * Fires when a referral code did not end up linked at sign-up.
 * Event: dental_portal:referrals:linked_failed
 *
 * Mirrors `mobile:referrals:linked_failed`; see `linkedSuccess` for why the
 * area segment is `referrals` and why no referrer or account id is carried.
 */
export function fireReferralLinkedFailed(payload: IReferralLinkedFailedPayload): void {
  PosthogService.getInstance().track('dental_portal:referrals:linked_failed', {
    reason: payload.reason,
    referral_code: payload.referral_code,
  });
}
